
<div class="detalle__movimiento">
    <div class="detalle__title-2">
        <h2>Zonas Pagas</h2>
        <div class="btn-group">
            <label>Buscar</label>
            <input type="text" [(ngModel)]="filter" placeholder="Ingrese búsqueda">
        </div>
    </div>
    <div class="movimientos movimientosComponent">
        <div class="movimientos__items">
            <div>
                <h2>Distrito</h2>
            </div>
            <div>
                <h2>Zona Paga</h2>
            </div>
            <div>
                <h2>Dirección</h2>
            </div>
            <div>
                <h2>Horario de Atención</h2>
            </div>
        </div>
        <div *ngIf="result.length === 0" class="alert red"><p>No se encontraron registros</p></div>
        <div *ngFor="let data of result; let i = index" class="movimientos__items content">
            <div class="body">
                <h2>Distrito</h2>
                <p>{{data.distrito}}</p>
            </div>
            <div class="body">
                <h2>Zona Paga</h2>
                <p>{{data.zonaPaga}}</p>
            </div>
            <div class="body">
                <h2>Dirección</h2>
                <p>{{data.direccion}}</p>
            </div>
            <div class="body">
                <h2>Horario de Atención</h2>
                <p>{{data.horario}}</p>
            </div>
        </div>
    </div>
</div>
